import React from 'react';
import PreviewPhoneFrame from '../digitalcard/PreviewPhoneFrame';

type LaptopProps = {
  src: string;
  alt: string;
  className?: string;
};

export const LaptopMockup: React.FC<LaptopProps> = ({ src, alt, className = '' }) => (
  <div className={`ftl-laptop ${className}`.trim()}>
    <div className="ftl-laptop-lid">
      <div className="ftl-laptop-camera" aria-hidden="true" />
      <div className="ftl-laptop-screen">
        <img src={src} alt={alt} loading="lazy" decoding="async" />
      </div>
    </div>
    <div className="ftl-laptop-base" aria-hidden="true" />
    <div className="ftl-laptop-notch" aria-hidden="true" />
  </div>
);

type HeroDevicesProps = {
  laptopSrc: string;
  laptopAlt: string;
  phoneSrc: string;
  phoneAlt: string;
};

export const HeroDevicePair: React.FC<HeroDevicesProps> = ({
  laptopSrc,
  laptopAlt,
  phoneSrc,
  phoneAlt,
}) => (
  <div className="ftl-hero-devices">
    <LaptopMockup src={laptopSrc} alt={laptopAlt} />
    <div className="ftl-hero-phone">
      <PreviewPhoneFrame src={phoneSrc} alt={phoneAlt} size="sm" />
    </div>
  </div>
);

type ShowcaseProps = {
  laptopSrc: string;
  laptopAlt: string;
  phones: Array<{ src: string; alt: string }>;
};

export const ProductShowcaseStage: React.FC<ShowcaseProps> = ({ laptopSrc, laptopAlt, phones }) => (
  <div className="ftl-device-stage">
    <div className="ftl-device-stage-laptop">
      <LaptopMockup src={laptopSrc} alt={laptopAlt} />
    </div>
    <div className="ftl-device-phones">
      {phones.map((phone) => (
        <PreviewPhoneFrame key={phone.src} src={phone.src} alt={phone.alt} size="sm" />
      ))}
    </div>
  </div>
);
